import { trasladosTypes } from './trasladosTypes';

export const cleanSolicitudTraslados = () => ({
  type: trasladosTypes.cleanSolicitud,
});
export const getSolicitudTraslados = (data) => ({
  type: trasladosTypes.getSolicitud,
  payload: data,
});

export const cleanSolicitudesTraslados = () => ({
  type: trasladosTypes.cleanSolicitudes,
});
export const getSolicitudesTraslados = (data) => ({
  type: trasladosTypes.getSolicitudes,
  payload: data,
});

export const cleanTipoDocSolicitudesTraslados = () => ({
  type: trasladosTypes.cleanTipoDocSolicitudes,
});
export const getTipoDocSolicitudesTraslados = (data) => ({
  type: trasladosTypes.getTipoDocSolicitudes,
  payload: data,
});
export const postTipoDocSolicitudesTraslados = (data) => ({
  type: trasladosTypes.postTipoDocSolicitudes,
  payload: data,
});
export const putTipoDocSolicitudesTraslados = (data) => ({
  type: trasladosTypes.putTipoDocSolicitudes,
  payload: data,
});
export const deleteTipoDocSolicitudesTraslados = (id) => ({
  type: trasladosTypes.deleteTipoDocSolicitudes,
  payload: id,
});
export const getAllSolicitudesTomadas = (data) => ({
  type: trasladosTypes.getAllSolicitudesTomadas,
  payload: data,
});
export const getByUserSolicitudesTomadas = (data) => ({
  type: trasladosTypes.getByUserSolicitudesTomadas,
  payload: data,
});
export const getTrackingSolicitud = (data) => ({
  type: trasladosTypes.getTrackingSolicitud,
  payload: data,
});
export const cleanTrackingSolicitud = (data) => ({
  type: trasladosTypes.cleanTrackingSolicitud,
  payload: data,
});
export const postSolicitudTomada = (data) => ({
  type: trasladosTypes.postSolicitudTomada,
  payload: data,
})
export const marcarTomada = (data) => ({
  type: trasladosTypes.marcarTomada,
  payload: data,
})
export const deleteSolicitudTomada = (data) => ({
  type: trasladosTypes.deleteSolicitudTomada,
  payload: data,
});
export const deleteSolicitudEnCarga = (idSolicitud) => ({
  type: trasladosTypes.deleteSolicitudEnCarga,
  payload: idSolicitud,
});
export const cambiarEstadoSolicitud = (data) => ({
  type: trasladosTypes.cambiarEstadoSolicitud,
  payload: data,
});
// DIM
export const getTiposTraslados = (data) => ({
  type: trasladosTypes.getTiposTraslados,
  payload: data,
});
export const getAccesorios = (data) => ({
  type: trasladosTypes.getAccesorios,
  payload: data,
});
export const getCausasTraslados = (data) => ({
  type: trasladosTypes.getCausasTraslados,
  payload: data,
});
export const getMotivosTraslados = (data) => ({
  type: trasladosTypes.getMotivosTraslados,
  payload: data,
});
export const getSectoresTraslados = (data) => ({
  type: trasladosTypes.getSectoresTraslados,
  payload: data,
});
export const getTipoSolicitudesTraslados = (data) => ({
  type: trasladosTypes.getTipoSolicitudes,
  payload: data,
});
export const getEstadosTraslados = (data) => ({
  type: trasladosTypes.getEstados,
  payload: data,
});
export const getCodigosTraslados = (data) => ({
  type: trasladosTypes.getCodigos,
  payload: data,
});
export const getTipoPrestaciones = (data) => ({
  type: trasladosTypes.getTipoPrestaciones,
  payload: data,
});
export const getTipoTracking = (data) => ({
  type: trasladosTypes.getTipoTracking,
  payload: data,
});
export const getNotasTraslado = (data) => ({
  type: trasladosTypes.getNotasTraslado,
  payload: data,
});
export const postNotaTraslado = (data) => ({
  type: trasladosTypes.postNotaTraslado,
  payload: data,
});
export const putNotaTraslado = (data) => ({
  type: trasladosTypes.putNotaTraslado,
  payload: data,
});
export const deleteNotaTraslado = (data) => ({
  type: trasladosTypes.deleteNotaTraslado,
  payload: data,
});